import React from "react";
import { FiHome } from "react-icons/fi";
import "./Landing.scss";

// Default property image
const DEFAULT_PROPERTY_IMAGE = "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&q=80";

function Landing() {
  return (
    <div className="landing-page dark-theme">
      {/* Background Image */}
      <div
        className="landing-page__background"
        style={{ backgroundImage: `url(${DEFAULT_PROPERTY_IMAGE})` }}
      />
      <div className="landing-page__overlay" />

      {/* Content */}
      <div className="landing-page__content">
        {/* Logo */}
        <div className="landing-logo">
          <img
            src="https://steasyhubprodus.blob.core.windows.net/public/logo-white.png"
            alt="EasyHub"
            className="landing-logo__image"
          />
        </div>

        {/* Main Card */}
        <div className="landing-card">
          <div className="landing-card__icon">
            <FiHome size={32} />
          </div>

          <h1 className="landing-card__title">Prime Pass</h1>

          <p className="landing-card__subtitle">
            Welcome to EasyHub Prime
          </p>

          <div className="landing-card__divider" />

          <p className="landing-card__message">
            Please use the link provided in your reservation email to access your guest portal.
          </p>
        </div>

        {/* Footer */}
        <div className="landing-footer">
          <p>Your digital key to a seamless stay</p>
        </div>
      </div>
    </div>
  );
}

export default Landing;
